import script from "./HowWeHelp.vue?vue&type=script&setup=true&lang=js"
export * from "./HowWeHelp.vue?vue&type=script&setup=true&lang=js"

import "./HowWeHelp.vue?vue&type=style&index=0&id=45dfe61e&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45dfe61e"]])

export default __exports__